export const singleMap = ({ setSelectedLayer, layers }) => {
    const mountEvent = () => {
        setSelectedLayer(layers[0]);
    };

    const dismountEvent = () => {
        layers.forEach((layer) => {
            layer.setVisible(true);
        })
    };

    return { mount: mountEvent, dismount: dismountEvent };
}